import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import toArray from 'utils/toArray';
function getCleanedIds(ids) {
  var filteredIds = toArray(ids).filter(Boolean);
  return filteredIds.length > 0 ? filteredIds : undefined;
}
function getShareRefIds(_ref) {
  var type = _ref.type,
    playlistIds = _ref.playlistIds,
    assetIds = _ref.assetIds;
  var cleanedPlaylistIds = getCleanedIds(playlistIds);
  var cleanedAssetIds = getCleanedIds(assetIds);
  var hasPlaylistIds = cleanedPlaylistIds && cleanedPlaylistIds.length > 0;
  var isAssetSharedOutsideOfPlaylist = type === 'asset' && !hasPlaylistIds;
  return {
    //  The share_ref_ids are the playlist ids and the share_context_ids are the asset ids...
    // Unless the asset is being shared outside of the context of a playlist in which case share_ref_ids are the assets and share_context_ids is undefined
    share_ref_ids: isAssetSharedOutsideOfPlaylist ? cleanedAssetIds : cleanedPlaylistIds,
    share_context_ids: isAssetSharedOutsideOfPlaylist ? undefined : cleanedAssetIds
  };
}
export default getShareRefIds;